import { useQueryClient } from "@tanstack/react-query";
import { useProtectTRPC } from "../trpc";

export function useInvalidateContracts() {
  const trpc = useProtectTRPC();
  const queryClient = useQueryClient();

  return () =>
    Promise.all([
      queryClient.invalidateQueries({
        queryKey: trpc.contracts.list.queryKey(),
      }),
      queryClient.invalidateQueries({
        queryKey: trpc.contracts.search.queryKey(),
      }),
    ]);
}
